import { Component, OnInit, ViewChild,TemplateRef} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ServicesService } from '../services/services.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { UiSwitchModule } from 'angular2-ui-switch'


@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {

	public loading = false;
  isLoader: boolean = false;
  public show:boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  spinLoader = {
    filter : false,
    delete : []
  };
  employeeUpdateForm: FormGroup;
  isListData=true;
  isOnePage=false;
  userDataPacket;
  isListDataEmpty =false;
  errorEmployeeDesignation: boolean = false;
  errorDeviceType: boolean = false;
  errorEmployeeIdNumber: boolean = false;
  errorEmployeeName: boolean = false;
  isFormSubmitted: boolean = false;

  constructor(private _services: ServicesService, private router: Router,private formBuilder: FormBuilder) { }
	

  ngOnInit() {
    this._services.checkToken('status');
    this.getPageRequest();
    this.employeeUpdateForm = this.formBuilder.group({
      employee_name: ['', Validators.required],
      email_id: ['', Validators.required],
      device_type: ['', Validators.required],
      id_number: ['', Validators.required],
      contact_no: ['', Validators.required],
      designation: ['', Validators.required],
      id:['', Validators.required],

    });

  }
  get f() { return this.employeeUpdateForm.controls; }

  fields = [
  		{
  			'field': 'first_name',
  			'title': 'Name',
  			'width': '18%',
  			'code':true,
  			'sort':true
  		},
  		{
  			'field': 'contact_no',
  			'title': 'Mobile',
  			'width': '18%',
  			'code':true,
  			'sort':false
  		},
  		{
  			'field': 'designation',
  			'title': 'Designation',
  			'width': '18%',
  			'code':true,
  			'sort':false
  		},
        {
          'field': 'email_id',
          'title': 'Email Id',
          'width': '19%',
          'code':true,
          'sort':false
        }

  ]
  
    
  resetSearchField(){
    this.spinLoader['filter'] = true;
    this.searchFields=[''];
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }
	
	sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
    'field' : '',
    'type'  : ''
  };

  sortBy(field, event){
    this.spinLoader['filter'] = true;
    this.oldField = (this.oldField != field) ? this.oldField : field;

    if(typeof this.oldField !== 'undefined'){
      ////console.log(document.getElementById('fa-'+this.oldField));

      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
    }

    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
    }

    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
		};
		

    this.getPageRequest();
  }

  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  route:string;
  searchFields= [];
  pages: any;
  listData = [];
  editData: Object = {};

  previousPage(){
    if(this.currentPage == 1){
      return;
    }

    this.currentPage = this.currentPage -1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();

  }

  nextPage() {
    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage(){
    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n){
    if(n>1){
      this.isOnePage=true;
    }else{
      this.isOnePage=false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }
  /*------------------------------Pagination Integration Starts Here------------------------*/
  totalData:any;
  getPageRequest(){

    this.route  = 'get-employee-list';

    switch(this.route){

      case 'get-employee-list' :{
        var data = {
          page  : this.currentPage,
          search: {
            'first_name' : this.searchFields['first_name']
          },
          sort  : this.sortingData
        };
      }
        break;
    }

    this.loading = true;
    const token    = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.route, token).subscribe((result: any) => {

      this.spinLoader['filter'] = false;
      this.isListData=false;

      this.listData = [];
			this.listData = result.result;
      // //console.log(this.listData);
      this.totalData = result.paginate.total;
      this.paginate = result.paginate;

      this.currentPage = result.paginate.current_page;
      if(this.listData.length === 0){
        this.isListDataEmpty = true;
      }
      if(result.paginate.current_page > result.paginate.last_page){
        this.currentPage = result.paginate.last_page;
      }

      this.getPages(this.paginate.last_page);

      for (let key in this.spinLoader) {
        if(key == 'delete'){
          this.spinLoader[key] = [];
        }else{
          this.spinLoader[key] = false;
        }
      }
    });
    return true;
  }
  userIsActive(userId,userEmail,userActiveVal){
    // //console.log(userActiveVal);
    var userAction = 'activate';
    var isActive = 1;
    if(userActiveVal === true){
      userAction = 'activate';
      isActive = 1;
    }else{
      userAction = 'deactivate';
      isActive = 0;
    }

    let data = {
      id: userId,
      status: isActive
    };
  swal({
      title: 'Are you sure?',
      text: 'You want to '+userAction+' user details of '+userEmail,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#163862',
      cancelButtonColor: 'rgb(245, 54, 92)',
      confirmButtonText: 'Yes'
    }).then((result) => {
        //console.log(result);
      if (result.value==true) {
        this.route  = 'user-activation';
        const token    = localStorage.getItem('userToken');
        this.spinLoader['filter'] = true;
        this._services.requestCreator(data, this.route, token).subscribe((result: any) => {
      this.loading = false;
      this.getPageRequest();
      // this.spinLoader['filter'] = false;
    });
  }else{
    this.getPageRequest();
    // this.spinLoader['filter'] = false;
  }
});
}
  
  userData:any ={
    'first_name':'',
    'email_id':'',
    'user_profile_image':'',
    'device_type':'',
    'id_number':'',
    'designation':'',
    'id':'',
    'contact_no':''

  };
  Show(userData:any){
    this.userData=userData;
    this.employeeUpdateForm.controls['employee_name'].setValue(this.userData['first_name']);
    this.employeeUpdateForm.controls['email_id'].setValue(this.userData['email_id']);
    this.employeeUpdateForm.controls['device_type'].setValue(this.userData['device_type']);
    this.employeeUpdateForm.controls['contact_no'].setValue(this.userData['contact_no']);
    this.employeeUpdateForm.controls['id_number'].setValue(this.userData['id_number']);
    this.employeeUpdateForm.controls['designation'].setValue(this.userData['designation']);
    this.employeeUpdateForm.controls['id'].setValue(this.userData['id']);
    


    this.show=true;
  }
  back(){
    this.show=false;
  }
  employeeUpdate(){
   //console.log(this.employeeUpdateForm.value);
    if(this.employeeUpdateForm.value.employee_name == '' || this.employeeUpdateForm.value.employee_name == null) {
      this.errorEmployeeName=true;
      return false;
    }else{
      this.errorEmployeeName=false;
    }
    if(this.employeeUpdateForm.value.device_type=='' || this.employeeUpdateForm.value.device_type==null ){
      this.errorDeviceType=true;
      return false;
    }else{
      this.errorDeviceType=false;
    }
    if(this.employeeUpdateForm.value.id_number=='' || this.employeeUpdateForm.value.id_number==null){
      this.errorEmployeeIdNumber=true;
      return false;
    }else{
      this.errorEmployeeIdNumber=false;
    }
    if(this.employeeUpdateForm.value.designation=='' || this.employeeUpdateForm.value.designation==null){
      this.errorEmployeeDesignation=true;
      return false;
    }else{
      this.errorEmployeeDesignation=false;
    }

    this._services.requestCreator(this.employeeUpdateForm.value,'update-employee', this._services.getToken()).subscribe((data:any) => {
      if (this._services.checkToken(data.status)) {
        if (data.status == '200') {
          // this.isFormSubmitted=false;
          swal({
            title: 'Client  Updated Successfully',
            text: 'You Successfully  Updated Client',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: 'rgb(17, 205, 239)',
            cancelButtonColor: 'rgb(245, 54, 92)',
            confirmButtonText: 'Yes'
          })
        } else {
          // this.isFormSubmitted=false;
        }
      }
    });
  }
}
